import axios from './axios'

const conditions = window.addiesaas.cart_rules.conditions || []

export default async function (rules, args) {
    var rulesToCheck = []
    var checkedRules = []
    for (const rule of rules) {
        if (!rule.conditions.rules.length) {
            checkedRules.push(rule)
            continue
        }

        await parseFrontendRules(rule.conditions.rules, args)

        rulesToCheck.push({
            id: rule.id,
            conditions: rule.conditions,
        })
    }

    if (rulesToCheck.length) {
        const config = window.addiesaas.config
        try {
            const { data: rulesConditionsResults } = await axios.post(`${config.apiUri}/customer/cart-rule/condition/check`, {
                rules: rulesToCheck
            })

            for (const checkedRule of rulesConditionsResults) {
                if (checkedRule.result) {
                    checkedRules.push(rules.find(x => x.id == checkedRule.id))
                }
            }

            return checkedRules
        } catch {
            return []
        }
    }

    return []
}

async function parseFrontendRules(rules, args) {
    for (const rule of rules) {
        if (conditions[rule.field]) {
            const condition = conditions[rule.field]

            rule.calculated = await conditionFunctions[condition.function](rule, args)
        }

        if (rule.rules) {
            await parseFrontendRules(rule.rules, args)
        }
    }
}

let cardCostDetailsPayload = null
let cartCostDetails = null

async function retrieveCartCostDetails() {
    const store = window.addiesaas.store

    const items = Object.values(store.getters['Shop/Orders/Cart/cartItems']).map(x => x.payload)
    const discounts = Object.values(store.getters['Shop/Orders/Cart/cartDiscounts']).map(x => x.payload)

    if (items.length) {
        const payload = { items, discounts }

        const payloadString = JSON.stringify(payload)

        if (!cartCostDetails || cardCostDetailsPayload != payloadString) {
            try {
                const { data: { data } } = await axios.post(`${window.addiesaas.config.apiUri}/customer/order/validate`, payload)
                cartCostDetails = data
                cardCostDetailsPayload = payloadString
                return true
            } catch {
            }
        } else {
            return true
        }
    }

    return false
}

const conditionFunctions = {
    async cartTotal() {
        if (await retrieveCartCostDetails()) {
            return cartCostDetails.total
        } else {
            return null
        }
    },

    async cartSubtotal() {
        if (await retrieveCartCostDetails()) {
            return cartCostDetails.price
        } else {
            return null
        }
    },

    cartItemsOfProduct(rule) {
        const productId = rule.value

        const cartItems = window.addiesaas.store.getters['Shop/Orders/Cart/cartItems']

        return Object.values(cartItems)
            .filter(item => item.payload.product_id == productId)
            .length
    },

    cartItemsOfProductType(rule) {
        const products = addiesaas.products.types[rule.value] ?? []
        const productIds = products.map(product => Number(product.id))
        const cartItems = window.addiesaas.store.getters['Shop/Orders/Cart/cartItems']

        return Object.values(cartItems)
            .filter(item => {
                return productIds.includes(Number(item.payload.product_id))
            }).length
    },

    cartCouponApplied(rule) {
        const couponCode = rule.value

        const cartDiscounts = window.addiesaas.store.getters['Shop/Orders/Cart/cartDiscounts']

        return Object.values(cartDiscounts)
            .filter(discount => discount.payload.type == 'coupon' && discount.payload.options.code == couponCode)
            .length
    },

    productId(rule, args) {
        return args.product_id || null
    },

    productLocationId(rule, args) {
        return args.location_id || window.addiesaas.location?.id || null
    },

    productCount(rule, args) {
        return args.item ? (args.item.payload.count || 1) : null
    },

    cardCash(rule, args) {
        return args.balance ? (args.balance.cash || null) : null
    },

    cardBonusCash(rule, args) {
        return args.balance ? (args.balance.bonus_cash || null) : null
    },

    cardCredits(rule, args) {
        return args.balance ? (args.balance.points || null) : null
    },

    cardBonusCredits(rule, args) {
        return args.balance ? (args.balance.bonus_points || null) : null
    },

    cardTickets(rule, args) {
        return args.balance ? (args.balance.tickets || null) : null
    },

    dataValue(rule, args) {
        const [value] = rule.value.split('|')
        return window.addiesaas.$fn.formatters.templify(`{{${value}}}`, args)
    },
}
